import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../../../config/index';
import { urlConstants } from '../../../constants/urlConstants';

export interface ExpoMasterItem {
  _id: string;
  name: string;
  description?: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export const expoMasterApi = createApi({
  reducerPath: 'expoMasterApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config().BASE_URL,
    prepareHeaders: (headers: any) => {
      const token = localStorage.getItem('cw-token');
      if (token && token !== 'null' && token !== 'undefined') {
        headers.set('Authorization', `Token ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['expoMaster'],
  endpoints: (builder) => ({
    createExpoMaster: builder.mutation<any, any>({
      query: (body: any) => ({
        url: urlConstants.EXPO_MASTER_ADD,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['expoMaster'],
    }),

    getExpoMasterList: builder.query<any, void>({
      query: () => ({
        url: urlConstants.EXPO_MASTER_LIST,
        method: 'GET',
      }),
      providesTags: ['expoMaster'],
    }),

    getSingleExpoMaster: builder.query<any, string>({
      query: (id: string) => ({
        url: `${urlConstants.EXPO_MASTER}/${id}`,
        method: 'GET',
      }),
      providesTags: ['expoMaster'],
    }),

    editExpoMaster: builder.mutation<any, { body: any; id: string }>({
      query: ({ body, id }) => ({
        url: `${urlConstants.EXPO_MASTER}/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['expoMaster'],
    }),

    deleteExpoMaster: builder.mutation<any, string>({
      query: (id: string) => ({
        url: `${urlConstants.EXPO_MASTER}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['expoMaster'],
    }),
  }),
});

export const {
  useCreateExpoMasterMutation,
  useGetExpoMasterListQuery,
  useGetSingleExpoMasterQuery,
  useEditExpoMasterMutation,
  useDeleteExpoMasterMutation,
} = expoMasterApi;
